"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeDataModels = void 0;
var _lodash = require("lodash");
/**
 * This function provides a customized merging strategy compared to `merge` from Lodash, specifically for handling array properties.
 *
 * `merge` from Lodash does not properly merge arrays.
 * For example, `_.merge({ instances: [1, 2] }, { instances: [] })` would result in `{ instances: [1, 2] }`,
 * while we need to override array with empty values like `{ instances: [] }`
 */
const mergeDataModels = (objA, objB, ...rest) => (0, _lodash.mergeWith)(objA, objB, ...rest, (valueA, valueB) => {
  if (Array.isArray(valueA) && Array.isArray(valueB)) {
    return valueB;
  }
  return undefined;
});
exports.mergeDataModels = mergeDataModels;